import React from 'react';

// Hooks
import { Link } from 'react-router-dom';

// Utils
import { EVENT_TYPES } from '~/utils/constants';
import { MESSAGES } from '~/utils/message';
import { dateFormat } from '~/utils/date-format';

// Components
import OlcDropdownSearch from '~/components/General/OlcDropdownSearch';
import Loader from '~/components/General/Loader';

// MUI Components
import { Box, Grid, Typography, Pagination, PaginationItem, Divider } from '@mui/material';

// Icons
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

// Styles
import './styles.scss';

const EventLog = (props) => {
  const { data, eventType, setEventType, loading, mainLoader, updatePagination } = props;

  const handleChangePage = (event, newPage) => {
    updatePagination({
      page: newPage,
      pageSize: 10,
    });
  };

  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box className="logSelect">
            <OlcDropdownSearch
              options={EVENT_TYPES}
              selectedValue={eventType}
              setSelectedValue={setEventType}
              placeHolderText="All"
              component="eventLogDropdown"
              searchable={false}
              selectClassName="eventDateSelect"
            />
          </Box>
        </Grid>
      </Grid>
      {loading && !mainLoader && <Loader />}
      {!loading && !mainLoader && data?.rows?.length === 0 ? (
        <Grid container mb={4}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Box className="emptyTabContent">
              <Typography variant="h6">{MESSAGES.CONTACTS.EVENTS_LOGS.NO_EVENT_LOGS}</Typography>
            </Box>
          </Grid>
        </Grid>
      ) : (
        !loading &&
        !mainLoader &&
        data?.rows?.map((log, index) => (
          <React.Fragment key={index}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {eventType?.title === 'QR Code' || log?.event === 'QR Scanned' ? (
                      <Grid container sx={{ alignItems: 'center', gap: '20px' }}>
                        {log?.lastQrScan?.scannedAt && (
                          <Grid item lg={12} md={12} sm={12} xs={12} className="borderedGrid">
                            <Box className="logContent">
                              <Typography>
                                {`QR Code was scanned at ${
                                  dateFormat(log?.lastQrScan?.scannedAt) || ''
                                }`}
                                {log?.lastQrScan?.orderId && (
                                  <>
                                    {`- from `}
                                    <Link
                                      to={`/orders/detail/overview/${log?.lastQrScan?.orderId}`}
                                      className="link"
                                    >
                                      <span
                                        style={{
                                          fontSize: '16px',
                                        }}
                                      >
                                        {' Order #' + log?.lastQrScan?.orderId}
                                      </span>
                                    </Link>
                                  </>
                                )}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    ) : log?.event === 'Order Placed' ? (
                      <Grid item lg={12} md={12} sm={12} xs={12} className="borderedGrid">
                        <Box className="logContent">
                          <Typography>
                            {`Order was created at ${dateFormat(log?.createdAt) || ' -'}`}
                            {log?.orderId && (
                              <>
                                {` - `}
                                <Link
                                  to={`/orders/detail/overview/${log?.orderId}`}
                                  className="link"
                                >
                                  <span
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {' Order #' + log?.orderId}
                                  </span>
                                </Link>
                              </>
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ) : log?.event === 'Order Canceled' ? (
                      <Grid item lg={12} md={7} sm={7} xs={7} className="borderedGrid">
                        <Box className="logContent">
                          <Typography>
                            {`Order was cancelled at ${dateFormat(log?.createdAt) || ' -'}`}
                            {log?.orderId && (
                              <>
                                {` - `}
                                <Link
                                  to={`/orders/detail/overview/${log?.orderId}`}
                                  className="link"
                                >
                                  <span
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {' Order #' + log?.orderId}
                                  </span>
                                </Link>
                              </>
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ) : (
                      <Grid container className="borderedGrid">
                        <Grid item lg={8} md={7} sm={7} xs={7}>
                          <Box className="logContent" sx={{ borderBottom: 'none' }}>
                            <Typography>
                              {log?.address1 + ',' + log?.address2}
                              {log?.address2 ? '. ' : ' '}
                              <span>{log?.event}</span>
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Box className="logDate">
                            <Typography>{dateFormat(log?.updatedAt) || ' -'}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        ))
      )}
      {data?.rows?.length > 0 && data?.total > 10 && (
        <Grid container>
          <Grid item lg={2} md={2} sm={2} xs={2}></Grid>
          <Grid item lg={10} md={10} sm={10} xs={10}>
            <Box
              className="tagsPaginationWrapper eventLogPagination"
              style={{ position: 'relative', marginTop: 20, marginBottom: 10 }}
            >
              <Pagination
                count={data?.lastPage || 0}
                variant="outlined"
                shape="rounded"
                onChange={handleChangePage}
                page={data?.currentPage || 1}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: ArrowBackIosNewIcon,
                      next: ArrowForwardIosIcon,
                    }}
                    {...item}
                  />
                )}
              />
              <Typography>
                Showing {data?.rows?.length ? data?.from : 0} to{' '}
                {data?.rows?.length < data?.to ? data?.from + data?.rows?.length - 1 : data?.to} of{' '}
                {data?.total} results
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default EventLog;
